import { useLookupsStore } from '@/stores/lookups'
import { defineStore } from 'pinia'

export const useCurrentVisaStore = defineStore('currentVisa', {
  state: () => {
    return {
      countries: [],
      passportTypes: []
    }
  },
  actions: {
    async fetchLookups() {
      const lookupsStore = useLookupsStore()

      const currentVisaParsed = JSON.parse(sessionStorage.getItem('currentVisa'))
      const { countries = [], passportTypes = [] } = currentVisaParsed || {}

      if (countries.length === 0) {
        this.countries = await lookupsStore.fetchLookup('/api/lookup/countries')
      }

      if (passportTypes.length === 0) {
        this.passportTypes = await lookupsStore.fetchLookup('/api/lookup/passportTypes')
      }
    }
  },
  persist: {
    storage: sessionStorage
  }
})
